import { TextField } from "@mui/material";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { PrimaryButton } from "app/components/Button/PrimaryButton";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Redirect from "../components/Redirect";
import { selectError, selectLoading, selectLoginForm } from "../selectors";
import { actions } from "../slice";
import { LoginErrorType } from "../types";
import { useLoginStyles } from "./styles";
import { isLoginFormComplete, validate } from "./validator";

export function LoginForm({ className }) {
  const classes = useLoginStyles();
  const form = useSelector(selectLoginForm);
  const isLoading = useSelector(selectLoading);
  const error = useSelector(selectError);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [errorMsg, setErrorMsg] = useState("");
  const { t, i18n } = useTranslation();
  interface State {
    password: string;
    showPassword: boolean;
  }
  const [values, setValues] = useState<State>({
    password: "",
    showPassword: false,
  });

  useEffect(() => {
    dispatch(actions.setForm({ key: "loginForm.email", value: "" }));
    dispatch(actions.setForm({ key: "loginForm.password", value: "" }));
    setErrorMsg("");
  }, [dispatch]);

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    dispatch(actions.setForm({ key: `loginForm.${name}`, value }));
  };
  const onSubmitForm = (evt?: React.FormEvent<HTMLFormElement>) => {
    try {
      evt?.preventDefault();
      setErrorMsg("");
      const errors = validate(form);
      if (errors.length > 0) {
        dispatch(actions.setFormErrors({ key: "loginForm", errors }));
        return;
      }
      dispatch(
        actions.submitLogin({
          callback: () => navigate("/home"),
        }),
      );
    } catch (e) {}
  };
  useEffect(() => {
    if (error) setErrorMsg(error);
  }, [error]);
  const errorText = errorMsg;
  return (
    <Redirect>
      <form className={classes.form} noValidate onSubmit={onSubmitForm}>
        {errorText && (
          <Alert className={classes.error} severity="error">
            {errorText}
          </Alert>
        )}
        <Box className={classes.welcomeRow}>
          <Typography className={classes.loginText} gutterBottom>
            {t("AUTH.WELCOME_MESSAGE")}{" "}
            <span className={classes.brandName}>Silagi</span>
          </Typography>
        </Box>
        <div dir="ltr" className={classes.fields}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            placeholder={t("AUTH.EMAIL")}
            name="email"
            autoComplete={"off"}
            error={!!form.email.error}
            helperText={form.email.error ? t(form.email.error) : ""}
            FormHelperTextProps={{
              className:
                i18n.dir() === "ltr" ? classes.helperStart : classes.helperEnd,
            }}
            autoFocus
            inputProps={{ inputMode: "email" }}
            value={form.email.value}
            onChange={onChange}
            className={classes.email}
          />
          <TextField
            id="outlined-adornment-password"
            name="password"
            placeholder={t("AUTH.PASSWORD")}
            type={values.showPassword ? "text" : "password"}
            value={form.password.value}
            onChange={onChange}
            error={!!form.password.error}
            helperText={form.password.error ? t(form.password.error) : ""}
            autoComplete={"off"}
            className={classes.password}
            FormHelperTextProps={{
              className:
                i18n.dir() === "ltr" ? classes.helperStart : classes.helperEnd,
            }}
          ></TextField>
          <Box className={classes.forgotWrap}>
            {/* <FormControlLabel
            sx={{ mb: 0, ml: 0 }}
            control={<Checkbox sx={{ p: 0, mr: 0 }} />}
            label={
              <Typography className={classes.labelKeepSignedIn} component="span">
                Remember me
              </Typography>
            }
          /> */}
            <Link
              to="/auth/recovery/forgot-password"
              className={classes.forgotPassword}
            >
              {t("AUTH.FORGOT_PASSWORD")}
            </Link>
          </Box>
        </div>
        {/* <Box className={classes.keepSignedin}>
        </Box> */}
        <PrimaryButton
          isLoading={isLoading}
          label={t("BUTTONS.LOG_IN")}
          disabled={!isLoginFormComplete(form)}
        />
        {/* <Box className={classes.signUpWrapper}>
          <Typography className={classes.dontHaveAccountText}>
            Don't have an account yet?
          </Typography>
          <Typography className={classes.signUpText}>SIGN UP</Typography>
        </Box> */}
      </form>
    </Redirect>
  );
}
export const loginError = (error: LoginErrorType | undefined | null) => {
  if (!error) return null;
  switch (error) {
    case LoginErrorType.ERROR:
      return {
        message: "An error has occurred! 😞",
        email: true,
        password: true,
      };
    case LoginErrorType.EMAIL_EMPTY:
      return { message: "Please enter email", email: true };
    case LoginErrorType.PASSWORD_EMPTY:
      return { message: "Please enter password", password: true };
    default:
      return { message: error, password: true, email: true };
  }
};
export default LoginForm;
